import Slider from 'react-slick';
import { useState } from 'react';
import { useEffect } from 'react';
import './index.css';
import UsersModal from '../UsersModal';
import { useDispatch } from 'react-redux';
import { getOurLearnersWorkAt } from '../../redux/actions/learnerWorkAt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { images } from "../../pages/Profile/imagelinks";
import {
    faUserCircle,
} from '@fortawesome/free-solid-svg-icons';
import useWindowSize from '../../hooks/useWindowSize';
import { useLocation } from 'react-router-dom';
import '../../pages/Pricing/pricingslider.css'
import { userPlacements } from '../../utils/userPlacementsData';


const OurLearnersWorkAt = () => {

    const dispatch = useDispatch()
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [usersData, setUsersData] = useState({data: userPlacements?.slice(0, 10)})
    const [imageArray, setImageArray] = useState([])
    const { width } = useWindowSize()
    const { pathname } = useLocation()

    console.log(pathname);

    // useEffect(()=> {
    //     dispatch(getOurLearnersWorkAt((successObj)=> setUsersData((prev)=> ({...prev, data : successObj?.data}))))
    // }, [])

    
  useEffect(() => {
    function modifiedArray(){
        const newArray = images?.sort((a,b)=> 0.5 - Math.random());
        setImageArray(newArray?.slice(0, 4))
    }
    modifiedArray()
  },[])
 
    const truncatedText = (text, noOfChar) => {
        if (text.length <= noOfChar){
            return text
        } else {
            const res = text.slice(0, noOfChar) + '...'
            return res
        }
    }

    const workAtsettings = {
        dots: false,
        slidesToShow: pathname === '/pricing' ? 5 : pathname === '/onboarding/analysis' || pathname === '/onboarding' ? 6 : 7,
        rows: 1,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 3000,
        easing: 'linear',
        cssEase: "linear",
        infinite: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                }
            },

            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3.5,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2.1,
                    infinite: true,
                    dots: false,
                    arrows: false,
                    swipeToSlide: false,
                }
            },
        ]
    };
    
    
  return (
        <>            
            <div className={`w-full arrows  ${pathname === '/pricing' && 'pricing-scroll'}`}>
                <Slider {...workAtsettings}>
                    {usersData && usersData?.data.map((item, index)=> (
                        <div key={index}>
                            <div className={`h-[9.5rem] mx-1 px-3 py-2 min-w-[8.3rem] ${pathname === '/' || pathname === '/onboarding/analysis' || pathname === '/onboarding' ? 'bg-[#2D4F71]' : 'bg-[#FFFFFF]'}  flex flex-col justify-start items-center rounded-xl shadow-md my-1`}>
                                
                                    {item?.user_details?.profile_image ? 
                                    <div className="relative">
                                        <div className='w-[50px] h-[50px]'>
                                            <img src={item?.user_details?.profile_image} alt="profile image" height="40" width="40" className='rounded-full h-full w-full object-fit'/>
                                        </div>
                                        { item?.user_details?.linkedin_url ?
                                                <button className="absolute top-8 left-8"
                                                    onClick={()=>{
                                                    window.open(item?.user_details?.linkedin_url, '_blank')
                                                }}
                                                >
                                                    <div className='w-[20px] h-[20px]'>
                                                        <img src={"https://assets.learntube.ai/files/Content_player/LinkdIn.png?updatedAt=1681563676400"} alt="linkedIn icon" className='w-full h-full object-cover' />
                                                    </div>
                                                </button> : null
                                        }
                                    </div>
                                    : 
                                    <div className='relative'>
                                        <div className='rounded-full h-[50px] w-[50px]'>
                                            <FontAwesomeIcon
                                            className="text-slate-600 text-[50px]"
                                            icon={faUserCircle}/>
                                        </div>
                                        { item?.user_details?.linkedin_url ? 
                                            <button className="absolute top-8 left-8"
                                                onClick={()=>{
                                                window.open(item?.user_details?.linkedin_url, '_blank')
                                                }}
                                            >
                                                <div className='w-[20px] h-[20px]'>
                                                    <img src={"https://assets.learntube.ai/files/Content_player/LinkdIn.png?updatedAt=1681563676400"} alt="LinkedIn icon" className='w-full h-full object-cover' />
                                                </div>
                                            </button> : null
                                        }
                                    </div>
                                    } 
                                            
                                <p className='text-sm w-full text-center pt-2 font-semibold truncate'>
                                    {item?.user_details?.name}
                                </p>
                                <p className='text-xs w-full font-medium text-center leading-3 truncate'>{item?.job_designation}</p>
                                <div className='flex justify-start mt-2 mx-2 items-center'>
                                    <div></div>
                                    <div className='w-[38px] h-[38px] mr-1'>
                                        <img src={item?.company_details?.company_image?.url} alt="company image" className='w-full h-full object-cover' style={{backgroundImage: '' , backgroundRepeat: 'no-repeat' , backgroundSize:'fill'}}/>
                                    </div>
                                    <p className='text-xs font-medium truncate'>{item?.company_details?.company_name ? width < 768 ?  truncatedText(item?.company_details?.company_name, 10) : truncatedText(item?.company_details?.company_name, 12) :null}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
            <div className="flex my-1 pt-2 justify-center items-center">
                <div className={`flex mr-3 ${pathname === '/onboarding' || pathname === '/onboarding/analysis' ? 'hidden' : ''}`}>{imageArray?.map((e)=> <img src={e} className="w-6 h-6 md:w-7 md:h-7 rounded-full outline outline-white -ml-1" alt="images"/>)}</div>
                <button className="underline font-semibold text-sm md:text-xl" onClick={()=>setIsModalOpen(true)}>
                    View 1000s More
                </button>
            </div>
            {isModalOpen && <UsersModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                usersData={usersData}
            />}
        </>
  )
}

export default OurLearnersWorkAt
